<template>
  <div v-loading="loading">
    <el-row :gutter="15">
      <el-col :span="12">
        <el-card style="height: 450px;">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>巡检统计
          </div>
          <el-row>
            <div class="es-op-box">
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" v-model="dateTimeRank" type="daterange" size="small" class="query"
                range-separator="至" start-placeholder="计划开始日期起始" end-placeholder="计划开始日期结束" clearable @change="() => {
                  loadLineCountNumber(); lodDepartLineRankListByDate()
                }">
              </el-date-picker>
            </div>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <div style="height:120px;">
                <el-col :span="8">
                  <div class="tatistic-rank-div">
                    <el-row class="tatistic-value">
                      <el-col :span="18">
                        <div style="margin-top: 20px;margin-right: -40px;">
                          {{ lineRankList != null && lineRankList.length > 0 ? ((lineRankList[0].attendance *
                            100)).toFixed(1) : 0 }}
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <el-image style="width: 40px; height: 40px;margin-left: -70px;margin-top: 10px;"
                          :src="require('../imgs/goldmedal.png')">
                        </el-image>
                      </el-col>
                    </el-row>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ lineRankList != null && lineRankList.length > 0 ? lineRankList[0].workAreaName : '' }}
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ lineRankList != null && lineRankList.length > 0 ? lineRankList[0].finishCount : '' }}
                      </el-row>
                    </el-col>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="tatistic-rank-div">
                    <el-row class="tatistic-value">
                      <el-col :span="18">
                        <div style="margin-top: 20px;margin-right: -40px;">
                          {{ lineRankList != null && lineRankList.length > 1 ? (lineRankList[1].attendance *
                            100).toFixed(1) :
                            0 }}
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <el-image style="width: 40px; height: 40px;margin-left: -70px;margin-top: 10px;"
                          :src="require('../imgs/silvermedal.png')">
                        </el-image>
                      </el-col>
                    </el-row>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ lineRankList != null && lineRankList.length > 1 ? lineRankList[1].workAreaName : '' }}
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ lineRankList != null && lineRankList.length > 1 ? lineRankList[1].finishCount : '' }}
                      </el-row>
                    </el-col>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="tatistic-rank-div">
                    <el-row class="tatistic-value">
                      <el-col :span="18">
                        <div style="margin-top: 20px;margin-right: -40px;">
                          {{ lineRankList != null && lineRankList.length > 2 ? (lineRankList[2].attendance *
                            100).toFixed(1) :
                            0 }}
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <el-image style="width: 40px; height: 40px;margin-left: -70px;margin-top: 10px;"
                          :src="require('../imgs/bronzemedal.png')">
                        </el-image>
                      </el-col>
                    </el-row>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ lineRankList != null && lineRankList.length > 2 ? lineRankList[2].workAreaName : '' }}
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ lineRankList != null && lineRankList.length > 2 ? lineRankList[2].finishCount : '' }}
                      </el-row>
                    </el-col>
                  </div>
                </el-col>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <div style="height:220px;">
              <el-col :span="16">
                <el-col :span="12">
                  <div class="tatistic-dialog-div">
                    <el-row class="tatistic-value">
                      <div style="margin-top: 20px;">
                        {{ LineCountNum != null ? LineCountNum.lineCount : 0 }}
                      </div>
                    </el-row>
                    <el-row class="tatistic-key">
                      巡检线路数
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="tatistic-dialog-div">
                    <el-row class="tatistic-value">
                      <div style="margin-top: 20px;">
                        {{ LineCountNum != null ? LineCountNum.totalcount : 0 }}
                      </div>
                    </el-row>
                    <el-row class="tatistic-key">
                      巡检设备总数
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="tatistic-dialog-div">
                    <el-row class="tatistic-value">
                      <div style="margin-top: 20px;">
                        {{ LineCountNum != null ? LineCountNum.planCount : 0 }}
                      </div>
                    </el-row>
                    <el-row class="tatistic-key">
                      巡检计划数
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="tatistic-dialog-div">
                    <el-row class="tatistic-value">
                      <div style="margin-top: 20px;">
                        {{ LineCountNum != null ? LineCountNum.finishCount : 0 }}
                      </div>
                    </el-row>
                    <el-row class="tatistic-key">
                      兑现总数
                    </el-row>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="8">
                <div id="finishAttendance" style="height:220px;"></div>
              </el-col>
            </div>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="height: 450px;">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>工区巡检统计
          </div>
          <el-row>
            <div class="es-op-box">
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" v-model="dateTimeTemp" type="daterange" size="small" class="query"
                range-separator="至" start-placeholder="计划开始日期起始" end-placeholder="计划开始日期结束" clearable @change="() => {
                  lodDepartLineTempListByDate()
                }">
              </el-date-picker>
            </div>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="16">
              <el-table :data="lineTempList" ref="lineTable" border stripe size="mini" height="350">
                <el-table-column prop="workAreaName" label="工区" align="center">
                </el-table-column>
                <el-table-column v-for="(item, index) in tableHeadLable" :key="index" :prop="item.prop"
                  :label="item.label">
                </el-table-column>
                <el-table-column prop="attendance" label="巡检数量占比" align="center">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="8">
              <div class="cbottom" id="lineTempAttendance">
              </div>
            </el-col>

          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="15">
      <el-col :span="12">
        <el-card id="dapartuserschart" style="height:calc(100vh - 580px);margin-top: 10px;">

          <div class="es-op-box">
            <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" v-model="dateTimeNum" type="daterange" size="small" class="query"
              range-separator="至" start-placeholder="计划开始日期起始" end-placeholder="计划开始日期结束" clearable @change="() => {
                lodDepartLineNumListByDate()
              }">
            </el-date-picker>
          </div>

          <el-table :data="lineNumList" ref="lineHoursTable" border stripe size="mini" height="calc(100vh - 650px)">
            <el-table-column prop="workAreaName" label="工区" align="center">
            </el-table-column>
            <el-table-column prop="finishCount" label="完成设备数量" align="center">
            </el-table-column>
            <el-table-column prop="totalCount" label="巡检总数量" align="center">
            </el-table-column>
            <el-table-column prop="attendance" label="兑现率" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.attendance != null">{{ (scope.row.attendance * 100).toFixed(1) }}%</span>
                <span v-else>0%</span>
              </template>
            </el-table-column>
          </el-table>

        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card id="dapartuserschart" style="height:calc(100vh - 580px);margin-top: 10px;">
          <div class="es-op-box">
            <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" v-model="dateTimePlan" type="daterange" size="small" class="query"
              range-separator="至" start-placeholder="计划开始日期起始" end-placeholder="计划开始日期结束" clearable @change="() => {
                lodDepartLinePlanListByDate()
              }">
            </el-date-picker>
          </div>
          <el-table :data="linePlanListPageData.list" ref="lineTable" border stripe size="mini"
            height="calc(100vh - 650px)">
            <el-table-column prop="workAreaName" label="工区" align="center">
            </el-table-column>
            <el-table-column prop="lineName" label="线路名称" align="center">
            </el-table-column>
            <el-table-column prop="starttime" label="开始时间" align="center">
            </el-table-column>
            <el-table-column prop="endtime" label="结束时间" align="center">
            </el-table-column>
            <el-table-column prop="finishCount" label="完成数量" align="center">
            </el-table-column>
            <el-table-column prop="totalCount" label="总数量" align="center">
            </el-table-column>
            <el-table-column prop="attendance" label="兑现率" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.attendance != null">{{ (scope.row.attendance * 100).toFixed(1) }}%</span>
                <span v-else>0%</span>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="es-page-box">
            <es-pagination :data="linePlanListPageData"
              @change="(cpage) => { this.queryObjPlan.pageNum = cpage; this.lodDepartLinePlanListByDate() }">
            </es-pagination>
          </div> -->
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'insstatistic',
  data () {
    return {
      queryObjTemp: { starttime: [], endtime: [] },//查询条件
      lineTempList: [],
      queryObjNum: { starttime: [], endtime: [], orderBy: 'attendance DESC' },//查询条件
      queryObjRank: { starttime: [], endtime: [], orderBy: 'attendance DESC' },//查询条件
      lineNumList: [],
      lineRankList: [],
      tableHeadLable: [],
      queryObjPlan: { starttime: [], endtime: [], orderBy: 'attendance' },
      linePlanListPageData: {},
      LineCountNum: {},
      dateTimeRank: [],
      dateTimeTemp: [],
      dateTimePlan: [],
      dateTimeNum: [],
      viewVisible: false,
      viewHourVisible: false,
      workAreaId: null,
      workAreaIdHour: null,
      loading: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.dateTimeRank = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeTemp = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimePlan = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeNum = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.lodDepartLineTempListByDate();
      this.lodDepartLinePlanListByDate();
      this.lodDepartLineNumListByDate();
      this.loadLineCountNumber();
      this.lodDepartLineRankListByDate();
    },

    lodDepartLineTempListByDate () {
      this.loading = true
      this.queryObjTemp.starttime = this.dateTimeTemp[0]
      this.queryObjTemp.endtime = this.dateTimeTemp[1]
      this.$ajax.get('/buss/statistic/departLineTempListByDate', this.queryObjTemp).then(msg => {
        this.lineTempList = msg
        if (msg.length > 0 && msg[0].count > 0) {
          this.tableHeadLable = []
          var map = msg[0];
          for (var i = 1; i <= map.count; i++) {
            var lable = new Object();
            lable.label = map['value' + i]
            lable.prop = "column" + i
            this.tableHeadLable.push(lable);
          }
        }
        var attendancePie = []
        for (var a = 0; a < msg.length - 1; a++) {
          var pa = new Object();
          pa.name = msg[a].workAreaName
          pa.value = msg[a].totalCountSum
          attendancePie.push(pa);
        }
        this.lineTempAttendancePie(attendancePie);
        this.viewHourVisible = true
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewHourVisible = false
        this.loading = false
      })
    },
    lodDepartLineNumListByDate () {
      this.loading = true
      this.queryObjNum.starttime = this.dateTimeNum[0]
      this.queryObjNum.endtime = this.dateTimeNum[1]
      this.$ajax.get('/buss/statistic/departLineNumListByDate', this.queryObjNum).then(msg => {
        this.lineNumList = msg
        this.viewHourVisible = true
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewHourVisible = false
        this.loading = false
      })
    },
    lodDepartLineRankListByDate () {
      this.loading = true
      this.queryObjRank.starttime = this.dateTimeRank[0]
      this.queryObjRank.endtime = this.dateTimeRank[1]
      this.$ajax.get('/buss/statistic/departLineNumListByDate', this.queryObjRank).then(msg => {
        this.lineRankList = msg
        this.viewHourVisible = true
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewHourVisible = false
        this.loading = false
      })
    },
    loadLineCountNumber () {
      this.loading = true
      this.queryObjRank.starttime = this.dateTimeRank[0]
      this.queryObjRank.endtime = this.dateTimeRank[1]
      this.$ajax.get('/buss/statistic/getLineCountNumber', this.queryObjRank).then(msg => {
        this.LineCountNum = msg
        this.finishAttendancePie(msg.finishCount == null ? 0 : msg.finishCount, msg.totalcount == null ? 0 : msg.totalcount);
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    lodDepartLinePlanListByDate () {
      this.loading = true
      this.queryObjPlan.starttime = this.dateTimePlan[0]
      this.queryObjPlan.endtime = this.dateTimePlan[1]
      this.$ajax.get('/buss/statistic/departLinePlanListByDate', this.queryObjPlan).then(msg => {
        this.linePlanListPageData = msg
        this.viewHourVisible = true
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewHourVisible = false
        this.loading = false
      })
    },
    lineTempAttendancePie (datelist,) {
      let myChart = this.$echarts.init(document.getElementById('lineTempAttendance'))
      var option = {
        color: ["#F86464", "#19DC7C", "#34A6FE", "#FA9022", "#DCDB01", "#8C70F8", "#2A4AD1", "#E76FE3", "#5032C0", "#168FB2"],
        title: {
          subtext: "工区巡检数量占比",
          x: '25%',
          y: '0%',
          textStyle: {
            fontSize: 28,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        },
        grid: {
          left: '2%',
          top: '1%',
          bottom: 10,
          right: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 14
          },
          formatter: "{b} : {c} ({d}%)"
        },

        calculable: true,
        series: [
          {
            type: 'pie',
            radius: ["6%", "8%"],
            center: ['55%', '50%'],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            data: [{
              name: '',
              value: 0,
              itemStyle: {
                normal: {
                  color: "#68c5ff"
                }
              }
            }]
          },
          {
            type: 'pie',
            radius: ["69.5%", "70%"],
            center: ['55%', '50%'],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false
              }
            },
            name: "",
            data: [{
              name: '',
              value: 0,
              itemStyle: {
                normal: {
                  color: "#0674bf"
                }
              }
            }]
          }, {
            stack: 'a',
            type: 'pie',
            radius: ['25%', '60%'],
            center: ['55%', '50%'],
            roseType: 'area',
            zlevel: 10,
            label: {
              normal: {
                formatter: '{d}%',
                borderWidth: 0,
                borderRadius: 4,
                padding: [0, -50],
                height: 40,
                fontSize: 12,
                align: 'center',
                rich: {
                  b: {
                    fontSize: 13,
                    lineHeight: 5,
                    color: '#41B3DC'
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 20,
                length2: 55
              },
              emphasis: {
                show: false
              }
            },
            data: datelist
          },]
      };

      myChart.setOption(option)
    },
    finishAttendancePie (finishCount, totalcount) {
      //故障完成率
      let alarmchart = this.$echarts.init(document.getElementById('finishAttendance'))
      let alarmoption = {
        title: {
          text: totalcount == 0 ? 0 : (finishCount * 100 / totalcount).toFixed(1) + "%",
          x: 'center',
          y: 'center',
          textStyle: {
            fontWeight: 'normal',
            color: '#0580f2',
            fontSize: '40'
          }
        },
        color: ['rgba(176, 212, 251, 1)'],
        legend: {
          show: true,
          itemGap: 12
        },

        series: [{
          name: 'Line 1',
          type: 'pie',
          clockWise: true,
          radius: ['50%', '66%'],
          itemStyle: {
            normal: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          hoverAnimation: false,
          data: [{
            value: totalcount == 0 ? 0 : (finishCount * 100 / totalcount).toFixed(1),
            name: '总兑现率',
            itemStyle: {
              normal: {
                color: { // 完成的圆环的颜色
                  colorStops: [{
                    offset: 0,
                    color: '#00cefc' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#367bec' // 100% 处的颜色
                  }]
                },
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            }
          }, {
            value: 100 - (totalcount == 0 ? 0 : (finishCount * 100 / totalcount).toFixed(1))
          }]
        }]
      }
      alarmchart.setOption(alarmoption);
    },
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.cbottom {
  width: 90%;
  height: 330px;
}

.tatistic-div {
  height: 85px;
  background: #c9e0f6;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-dialog-div {
  height: 100px;
  background: #c9e0f6;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-rank-div {
  height: 100px;
  background: #c1c8fa;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}


.tatistic-value {
  color: rgb(68, 67, 67);
  margin-top: 6px;
  font-size: 24px;
}

.tatistic-key {
  color: rgb(126, 125, 125);
  margin-top: 10px;
  /* text-align: right; */
  font-size: 14px;
}

.context-icon {
  font-size: 40px;
  font-weight: 500;
  margin-top: 15px;
  margin-left: -60px;
}
</style>
